import axios from 'axios';
import Cookies from 'js-cookie';

export const createRequest = (options) =>
    new Promise((resolve, reject) => {
        const body = {
            method: options.method,
            url: options.url,
            headers: options.headers || {},
            withCredentials: true,
            data: options.body,
            params: options.qs
        };
        body.headers['CSRF-Token'] = Cookies.get('_csrf');
        if (Cookies.get('email')) {
            body.headers.email = Cookies.get('email');
        }
        axios
            .request(body)
            .then((res) => {
                resolve(res.data);
            })
            .catch((error) => {
                if (error.response && error.response.status === 401) {
                    Cookies.remove('email');
                    Cookies.remove('user_id');
                    Cookies.remove('_csrf');
                    Cookies.remove('tenantId');
                    window.location.reload();
                }
                reject(error);
            });
    });
